import styled from "styled-components";

export const TextInputStyles = styled.input`
    // background-color: red;
    font-size: 1.2em;
    background-color: rgba(0, 0, 0, 0.1);
    width: 75%;
    height: 45px;
    border-color: #282c34;
    border-radius: 2% 5% 2% 5%;
`;